import { Controller, useFormContext } from 'react-hook-form'

import { DatePicker, FF2 } from 'ui/components'
import { SarEdit } from '~bank-bsa-reporting/types'

export const LEContactDate = () => {
  const { control } = useFormContext<SarEdit>()

  return (
    <Controller
      name="institutionContactInfo.leContactDate"
      control={control}
      render={({ field }) => (
        <FF2 label="92. LE contact date" field={field} input={(props) => <DatePicker {...props} />} />
      )}
    />
  )
}
